import React, { forwardRef } from "react";
import { getClassNames } from "../../../utils";

type TabHeaderProps = {
    tab?: React.ReactNode;
    isActive?: boolean;
    disabled?: boolean;
    onClick?: React.KeyboardEventHandler<HTMLDivElement> | React.MouseEventHandler<HTMLDivElement>;
};

const TabHeader = forwardRef<HTMLDivElement, TabHeaderProps>((props, ref) => {
    const {
        tab = null,
        isActive = false,
        disabled = false,
        onClick = () => {},
    } = props;

    const className = getClassNames(
        "Tab",
        { "Tab-active": isActive },
        { "Tab-disabled": disabled }
    );

    return (
        <div
            ref={ref}
            role="tab"
            tabIndex={disabled ? -1 : 0}
            aria-disabled={disabled}
            aria-selected={isActive}
            className={className}
            onClick={onClick as React.MouseEventHandler<HTMLDivElement>}
            onKeyPress={onClick as React.KeyboardEventHandler<HTMLDivElement>}
        >
            {tab}
        </div>
    );
});


export default TabHeader;
